import { ColumnProps } from 'antd/lib/table'
/**
 * This function adds a onclick function to every cell of a table.
 * This can be used to e.g. open up a "show"-modal.
 * @param columns a columns object that will be passed to a table
 * @param onRowClicked a function that should executed when a row is clicked
 * @returns a columns object
 */
export const addRowClickHandler = (
  columns: Array<ColumnProps<any>>,
  onRowClicked: (record: any, index?: number) => void,
) =>
  columns.map((column) => {
    if (column.dataIndex !== 'action') {
      column.onCell = (record, index) => ({
        onClick: () => onRowClicked(record, index),
      })
    }

    return column
  })
